<div class="departments-page">

  <div class="page-header">

    <div>

      <div class="breadcrumb">
        HR Management / Departments
      </div>

      <h1>
        Departments
      </h1>

      <p>
        Manage organizational departments and structure.
      </p>

    </div>

    <button
      mat-raised-button
      color="primary"
      (click)="addDepartment()">

      <mat-icon>
        add
      </mat-icon>

      Add Department

    </button>

  </div>


  <mat-card class="departments-card">

    <div class="filters">

      <mat-form-field appearance="outline" class="search-field">

        <mat-label>
          Search departments
        </mat-label>

        <input
          matInput
          [(ngModel)]="filterText"
          (ngModelChange)="filterDepartments()"
          placeholder="Department name or head">

        <mat-icon matSuffix>
          search
        </mat-icon>

      </mat-form-field>

    </div>

    <mat-divider></mat-divider>

    <div class="table-container">

      <table
        mat-table
        [dataSource]="filteredDepartments"
        class="departments-table">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            Department Name
          </th>
          <td mat-cell *matCellDef="let dept">
            <div class="dept-info">
              <div class="dept-icon">
                <mat-icon>business</mat-icon>
              </div>
              <strong>{{ dept.name }}</strong>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="head">
          <th mat-header-cell *matHeaderCellDef>
            Department Head
          </th>
          <td mat-cell *matCellDef="let dept">
            {{ dept.head }}
          </td>
        </ng-container>

        <ng-container matColumnDef="employees">
          <th mat-header-cell *matHeaderCellDef>
            Employees
          </th>
          <td mat-cell *matCellDef="let dept">
            {{ dept.employeeCount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="budget">
          <th mat-header-cell *matHeaderCellDef>
            Budget
          </th>
          <td mat-cell *matCellDef="let dept">
            {{ dept.budget }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            Status
          </th>
          <td mat-cell *matCellDef="let dept">
            <span class="status-badge active">
              {{ dept.status }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            Actions
          </th>
          <td mat-cell *matCellDef="let dept">

            <button
              mat-icon-button
              matTooltip="Edit"
              (click)="editDepartment(dept)">

              <mat-icon>edit</mat-icon>

            </button>

            <button
              mat-icon-button
              color="warn"
              matTooltip="Delete"
              (click)="deleteDepartment(dept)">

              <mat-icon>delete</mat-icon>

            </button>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <div class="no-data" *ngIf="filteredDepartments.length === 0">

        <mat-icon>
          business_center
        </mat-icon>

        <h3>
          No Departments Found
        </h3>

        <p>
          Add a new department to get started.
        </p>

      </div>

    </div>

  </mat-card>

</div>
